import * as S from './styles'
import { useAuthor } from './useAuthor'
import { Image, Text } from '@/components'
import { Article } from '@/service/api/blog'

export type AuthorContainerProps = {
  data: Article['author']
}
export const AuthorContainer: React.FC<AuthorContainerProps> = ({ data }) => {
  const { fontSizes, responsiveSizes } = useAuthor()
  return (
    <S.AuthorContainer>
      <div className="card-author">
        <Image
          src={data.avatar}
          alt={data.name}
          className="avatar"
          defaultSize={{
            height: 200,
            width: 200,
          }}
          responsiveSizes={responsiveSizes}
        />
        <Text align="center" size={fontSizes.title}>
          {data.title}
        </Text>
        <Text align="center" size={fontSizes.author}>
          {data.name}
        </Text>
        <Text align="center" size={fontSizes.office}>
          {data.role}
        </Text>
      </div>
    </S.AuthorContainer>
  )
}
